/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Smart Home API
 * A smart home management system providing REST APIs for device integrations and automation
 * OpenAPI spec version: 1.0
 */

export type DevicesDeviceCommand = (typeof DevicesDeviceCommand)[keyof typeof DevicesDeviceCommand];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DevicesDeviceCommand = {
  DeviceCommandVolumeUp: 'volumeUp',
  DeviceCommandVolumeDown: 'volumeDown',
  DeviceCommandChannelUp: 'channelUp',
  DeviceCommandChannelDown: 'channelDown',
  /** Toggle mute on/off (TVs and speakers with Mute capability) */
  DeviceCommandToggleMute: 'toggleMute',
  /** Toggle on/off state */
  DeviceCommandToggleOnOff: 'toggleOnOff',
  /** Toggle between play and pause */
  DeviceCommandPlayPause: 'playPause',
  /** Stop playback */
  DeviceCommandStop: 'stop',
  /** Next track/chapter */
  DeviceCommandNext: 'next',
  /** Previous track/chapter */
  DeviceCommandPrevious: 'previous',
} as const;
